const initialState = {
    // General
    lieu: null,
    usage: null,
    dispositif: null,
    zone_fiscal: null,
    status_lot: null,
    nouveaute_depuis: null,
    nature_du_mandat: null,
    // Economic
    budget_min: null,
    budget_max: null,
    prix_m2_min: null,
    prix_m2_max: null,
    honoraires_min: null,
    rentabilite_min: null,
    // Lot
    num_lot: null,
    nature_lot: null,
    typologie_lot: null,
    etage: null,
    surface_min: null,
    surface_max: null,
    terrase_balcon_jardin_min: null,
    terrase_balcon_jardin_max: null,
    annexe: null,
    // Programme
    programme: null,
    promoteur: null,
    nouveaute_depuis_programme: null,
    tag: null,
    label: null,
    lot_maximum: null,
    mes_activitées: false,
    allotement: false,
    offre_speciale: false,
    // Search history
    searchHistory: null,
    loading: true,
};

const deepsearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case "LOAD_INITIAL_DATA":
            return {
                ...state,
                lieu: action.payload.cities,
                promoteur: action.payload.promoteurs,
                programme: action.payload.programmes,
                num_lot: action.payload.lots,
                dispositif: action.payload.projectTypes,
                status_lot: action.payload.disponibilities,
                zone_fiscal: action.payload.fiscalZones,
                orientations: action.payload.orientations,
                loading: false,
            };
        default:
            return state;
    }
};

export default deepsearchReducer;
